export const billingTransactionTypeTag = 'type:';
